  let regulament = document.getElementsByClassName("regulament");
  let linkBanner = document.getElementById("link-banner");
  let arrayRegulaments = Array.from(regulament);

  for(let i = 0; i < arrayRegulaments.length; i++){
      arrayRegulaments[i].addEventListener("click", () =>{
        linkBanner.removeAttribute("href");
        setTimeout(() =>{
            linkBanner.setAttribute("href", "/pages/modalitati-de-plata");
        }, 500);
        window.open("https://cdn.shopify.com/s/files/1/0021/3041/1580/files/Regulament_MC_Mobexpert_2023-1.pdf?v=1701957137", "_blank");
    }, false);  
  }